var _g, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMp3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_1_173)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55 20C46.1634 20 39 27.1634 39 36V204C39 212.837 46.1634 220 55 220H185C193.837 220 201 212.837 201 204V70L151 20H55Z",
    fill: "#F16C00"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.149 119.802C161.852 121.278 161.268 122.681 160.43 123.931C159.748 124.968 159.055 125.663 158.361 125.311C157.679 125.311 157.326 120.83 156.995 120.135C156.466 118.93 156.118 117.653 155.961 116.347C155.619 113.59 154.585 111.162 152.856 110.135C151.139 108.756 148.739 107.718 145.635 107.022C142.265 106.367 139.088 104.956 136.343 102.895C133.591 100.82 130.498 99.0983 128.78 97.0233C127.051 95.302 125.675 94.9483 124.993 95.302C123.958 95.6445 123.616 96.682 123.616 97.7183V161.875C123.616 163.607 123.275 165.671 122.581 167.746C121.899 169.821 121.546 171.883 119.829 173.948C118.111 176.023 115.701 177.402 112.608 178.782C109.503 180.162 105.726 180.857 101.588 181.198C97.3203 181.468 93.0555 180.636 89.2025 178.782C85.8871 177.259 82.9505 175.02 80.6038 172.226C78.535 169.467 77.5 166.708 77.5 163.253C77.5 160.153 78.8875 157.051 81.98 154.291C84.7325 151.532 87.8263 149.458 91.2713 148.421C94.7075 147.383 97.8113 146.7 100.905 146.7C104.009 146.7 108.82 146.7 111.23 147.393C113.631 148.078 115.36 148.431 116.735 148.773V87.7108C116.735 85.6358 117.419 83.9233 118.454 82.5445C119.488 81.1645 121.205 80.4695 122.923 80.1283C124.651 79.7858 126.028 80.1283 127.061 81.1658C128.096 81.8495 127.061 83.2395 128.428 84.6083C129.463 85.9883 130.839 87.7208 132.566 89.7845C134.284 91.8595 136.343 93.5808 139.095 95.3033C141.506 97.0245 143.575 98.062 145.293 99.0995C147.011 99.7845 148.739 100.48 150.115 101.175C151.49 101.858 153.209 102.543 154.585 103.581C155.96 104.618 157.689 105.997 159.396 108.072C161.124 110.147 162.149 111.858 162.5 113.932C162.5 116.007 162.5 118.071 162.149 119.793V119.803V119.802Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M196.309 65.3125H155.688L201 110.625V70L196.309 65.3125Z",
    fill: "url(#paint0_linear_1_173)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M167 70L201 70L151 20L151 54C151 62.8366 158.163 70 167 70Z",
    fill: "#F9C499"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_1_173",
    x: 39,
    y: 19,
    width: 162,
    height: 202,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_173"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1_173",
    result: "effect2_innerShadow_1_173"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_173",
    x1: 165.844,
    y1: 55.1563,
    x2: 211.156,
    y2: 100.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp3);
export default __webpack_public_path__ + "static/media/mp3.538ab181fa77f5b86907759ffbf1ac3b.svg";
export { ForwardRef as ReactComponent };